import { FC } from 'react';
import { useDispatch } from 'react-redux';

import { actions as jobActions } from '@/api/jobs';
import { useToastContext } from '@payaca/ambrosia';
import LoaderOverlay from '@payaca/components/loaderOverlay/LoaderOverlay';
import { getUrlSearchParam } from '@payaca/helpers/urlHelper';
import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import EditJobPage from '../editJobPage/EditJobPage';

type Props = {
  match: any;
  history: any;
  isNew?: boolean;
};
const NewEditInvoicePage: FC<Props> = ({ match, isNew = false }: Props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const invoiceId = useMemo(
    () => match?.params?.invoiceId?.split('?')[0],
    [match]
  );
  const dealId = useMemo(() => {
    return getUrlSearchParam(location.search, 'dealId');
  }, [location]);
  const [isInitialising, setIsInitialising] = useState(!invoiceId);

  const { pushError } = useToastContext();

  useEffect(() => {
    if (!invoiceId) {
      setIsInitialising(true);
      dispatch(
        jobActions.createJob(
          false,
          (err: any, job: any) => {
            setIsInitialising(false);
            if (job) {
              // history replace so navigating back will go to dashboard not /new
              history.replace({
                pathname: `/invoices/${job.id}/create/new`,
                search: dealId ? `?dealId=${dealId}` : '',
              });
            } else {
              pushError(
                <>
                  <strong>Something went wrong</strong> Please click the chat
                  button and let us know about it.
                </>
              );
            }
          },
          dealId as any
        )
      );
    }
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has missing dependencies: 'dispatch', 'pushError', and 'dealId'
  }, [invoiceId, history]);

  if (isInitialising) {
    return <LoaderOverlay />;
  }

  return (
    <EditJobPage
      jobId={+invoiceId}
      viewType={match?.params?.view}
      sendJobToCustomer={(
        id: number,
        payload: any,
        cb: (err: any, response: any) => void
      ) => dispatch(jobActions.sendInvoiceToCustomer(id, payload, cb))}
    />
  );
};

export default NewEditInvoicePage;
